module.exports = __webpack_public_path__ + "static/media/science.1047f34b.svg";